module.exports = __webpack_public_path__ + "img/5.151885fa.jpg";